import React from 'react';
import { Button, Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, Input, Label, } from '@cargomatic/ui';
import { Loader2 } from 'lucide-react';
export default function AddBaseCostDialog({ open, ledger, baseCostValue, onBaseCostValueChange, onSave, onClose, isSaving, }) {
    return (React.createElement(Dialog, { open: open, onOpenChange: onClose },
        React.createElement(DialogContent, { className: "sm:max-w-[400px]" },
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null,
                    "Add Base Cost (",
                    ledger === 'receivables' ? 'Shipper' : 'Carrier',
                    ")")),
            React.createElement("div", { className: "py-4" },
                React.createElement(Label, { htmlFor: "baseCostValue", className: "text-sm font-medium" }, "Value ($)"),
                React.createElement(Input, { id: "baseCostValue", type: "number", min: "0", step: "0.01", value: baseCostValue, onChange: (e) => onBaseCostValueChange(e.target.value), placeholder: "Enter base cost value", className: "mt-2" })),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { variant: "outline", onClick: onClose, disabled: isSaving }, "Cancel"),
                React.createElement(Button, { onClick: onSave, disabled: isSaving || !baseCostValue || parseFloat(baseCostValue) <= 0, className: "bg-zinc-900 text-white hover:bg-zinc-800" }, isSaving ? (React.createElement(React.Fragment, null,
                    React.createElement(Loader2, { className: "h-4 w-4 mr-2 animate-spin" }),
                    "Saving...")) : ('Add Base Cost'))))));
}
